module.exports = __webpack_public_path__ + "media/general_icons/x_in_circle_red-f55c1c5c.svg";